<div id="nav-content">
  <div>
    <dx-toolbar id="toolbar" class="header-toolbar">
      <dxi-item widget="dxButton" [options]="buttonOptions" cssClass="menu-button" location="before">
      </dxi-item>
      <dxi-item location="before" cssClass="ap-logo-wrapper" [width]="100">
        <div>
          <div>
            <h2 class="ap-green appheader title">
              Analysis on Demand
            </h2>
          </div>
        </div>
      </dxi-item>
    </dx-toolbar>
  </div>
  <dx-drawer [(opened)]="isOpened" [minSize]="37" revealMode="expand" openedStateMode="overlap"
    openedStateMode="overlap" class="layout-body" position="before" [closeOnOutsideClick]="shaderEnabled"
    [openedStateMode]="menuMode" [revealMode]="menuRevealMode" [minSize]="minMenuSize" [shading]="shaderEnabled"
    [(opened)]="menuOpened">
    <app-side-navigation-menu [compactMode]="!menuOpened" [selectedItem]="selectedRoute" class="dx-swatch-additional"
      *dxTemplate="let dataMenu of 'panel'" (selectedItemChanged)="navigationChanged($event)"
      (openMenu)="navigationClick()">
    </app-side-navigation-menu>

    <dx-scroll-view class="full-height-scrollable">
      <div class="content">
        <ng-content></ng-content>
        <router-outlet></router-outlet>
      </div>
    </dx-scroll-view>
  </dx-drawer>

</div>